// src/modules/Courier/pages/CourierModal/pages/Scanners/ScannerSettingsPage.jsx
import React, { useState, useEffect } from 'react';
import { useModalPage } from '../CourierModal';
import styles from '../styles/ScannerSettingsPage.module.css';

export default function ScannerSettingsPage() {
  const { goTo } = useModalPage();

  const scanBeepKey = 'scanner.scanSoundOn';
  const overlayKey  = 'scanner.overlaySize';
  const qrboxKey    = 'scanner.useQrBox';
  const vibrationKey      = 'scanner.scanVibrationOn';

  const [scanSoundOn, setScanSoundOn] = useState(() => {
    const stored = localStorage.getItem(scanBeepKey);
    return stored !== null ? JSON.parse(stored) : true;
  });
  const [overlaySize, setOverlaySize] = useState(() => {
    const stored = localStorage.getItem(overlayKey);
    return stored !== null ? Number(stored) : 150;
  });
  const [useQrBox, setUseQrBox] = useState(() => {
    const stored = localStorage.getItem(qrboxKey);
    return stored !== null ? JSON.parse(stored) : true;
  });
  const [scanVibrationOn, setScanVibrationOn] = useState(() => {
    const stored = localStorage.getItem(vibrationKey);
    return stored !== null ? JSON.parse(stored) : false;
  });

  // Сохраняем настройки
  useEffect(() => {
    localStorage.setItem(scanBeepKey, JSON.stringify(scanSoundOn));
  }, [scanSoundOn]);
  useEffect(() => {
    localStorage.setItem(overlayKey, String(overlaySize));
  }, [overlaySize]);
  useEffect(() => {
    localStorage.setItem(qrboxKey, JSON.stringify(useQrBox));
  }, [useQrBox]);
   useEffect(() => {
    localStorage.setItem(vibrationKey, JSON.stringify(scanVibrationOn));
  }, [scanVibrationOn]);

  return (
    <div className={styles.container}>
      <button
        type="button"
        className={styles.backButton}
        onClick={() => goTo('scan')}
      >
        Назад к сканеру
      </button>

      <div className={styles.settingItem}>
        <span className={styles.label}>Звук бипа при сканировании</span>
        <label className={styles.toggleSwitch}>
          <input
            type="checkbox"
            checked={scanSoundOn}
            onChange={() => setScanSoundOn(v => !v)}
          />
          <span className={styles.slider}></span>
        </label>
      </div>
      <div className={styles.settingItem}>
        <span className={styles.label}>Вибрация при сканировании</span>
        <label className={styles.toggleSwitch}>
          <input
            type="checkbox"
            checked={scanVibrationOn}
            onChange={() => setScanVibrationOn(v => !v)}
          />
          <span className={styles.slider}></span>
        </label>
      </div>

      <div className={styles.settingItem}>
        <span className={styles.label}>Ограниченная зона сканирования</span>
        <label className={styles.toggleSwitch}>
          <input
            type="checkbox"
            checked={useQrBox}
            onChange={() => setUseQrBox(v => !v)}
          />
          <span className={styles.slider}></span>
        </label>
      </div>

      <div className={styles.settingItem}>
        <span className={styles.label}>Размер зоны сканирования</span>
        <div className={styles.radioGroup}>
          {[100, 150, 200, 250].map(size => (
            <label key={size} className={styles.radioOption}>
              <input
                type="radio"
                name="overlaySize"
                value={size}
                checked={overlaySize === size}
                onChange={() => setOverlaySize(size)}
              />
              <span className={styles.radioText}>{size}×{size}</span>
            </label>
          ))}
        </div>
      </div>

      <div className={styles.note}>
        Чем меньше зона сканирования — тем выше производительность!
      </div>
    </div>
  );
}
